import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface State {
  isSideNavOpen: boolean
  isModalOpen: boolean
  toggleSideNav: () => void
  toggleModal: () => void
}

const useDashboardStore = create(
  persist<State>(
    (set) => ({
      isSideNavOpen: true,
      isModalOpen: localStorage.getItem('isModalOpen')
        ? JSON.parse(localStorage.getItem('isModalOpen') || '')
        : true,
      toggleSideNav: () =>
        set((state) => ({ isSideNavOpen: !state.isSideNavOpen })),
      toggleModal: () => {
        set((state) => {
          const newModalState = !state.isModalOpen
          localStorage.setItem('isModalOpen', String(newModalState))
          return { isModalOpen: newModalState }
        })
      }
    }),
    {
      name: 'dashboard-storage', // unique name for session storage
      storage: createJSONStorage(() => sessionStorage)
    }
  )
)

// Usage in a component

export function useDashboard() {
  const state = useDashboardStore((state) => state.isSideNavOpen)
  const isModalOpen = useDashboardStore((state) => state.isModalOpen)
  const toggleSideNav = useDashboardStore((state) => state.toggleSideNav)
  const toggleModal = useDashboardStore((state) => state.toggleModal)

  return {
    state: { isSideNavOpen: state, isModalOpen },
    actions: { toggleSideNav, toggleModal }
  }
}
